import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import MapaGeofences from '../../generals/mapGeofences'
import styles from '../../../css/modals/ModalInformation.module.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ModalInformationFence ({ fence, onClose, show, title }) {
  const data = {
    id: fence?.id,
    lat: fence?.lat,
    lon: fence?.lon,
    place: fence?.place,
    area: fence?.area,
    color_range: fence?.color_range
  }

  const { t } = useTranslation('geofences')

  return (
        <Modal
            show={show}
            size="lg"
            onHide={() => onClose('information')}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '1.5rem' }}>
                <div className={`${styles.containerMap}`}>
                {data && <MapaGeofences info={data} type="information"/>}
                </div>
                <div className={`${styles.containerInformationFence}`}>
                    <div className={`${styles.containerFlex}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input1')}</p>
                        <p>{fence?.name}</p>
                    </div>
                    <div className={`${styles.containerFlex}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input2')}</p>
                        <p>{fence?.description}</p>
                    </div>
                    <div className={`${styles.containerFlex}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input3')}</p>
                        <p>{fence?.type}</p>
                    </div>
                    <div className={`${styles.containerFlex}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input4')}</p>
                        <p>{fence?.area}{t('modalInformationFence.label1')}</p>
                    </div>
                    <div className={`${styles.containerFlexCoordinates}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input5')}</p>
                        <ul>
                            <li>{t('modalInformationFence.li1')}{fence?.lat}</li>
                            <li>{t('modalInformationFence.li2')}{fence?.lon}</li>
                        </ul>
                    </div>
                    <div className={`${styles.containerFlexDate}`}>
                        <p className={`${styles.bold}`}>{t('modalInformationFence.input6')}</p>
                        <p>{fence?.date_order}</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
            <Button
                onClick={() => onClose('information')}
                variant="danger"
            >
                {t('modalInformationFence.button')}
            </Button>
            </Modal.Footer>
        </Modal>
  )
};

ModalInformationFence.propTypes = {
  onClose: PropTypes.string,
  fence: PropTypes.object,
  show: PropTypes.func,
  title: PropTypes.string
}
